import React, { useState, useEffect, useRef } from "react";
import { io } from "socket.io-client";

const baseUrl = window.__RUNTIME_CONFIG__.REACT_APP_BASE_URL;
const socket = io(baseUrl);

export default function Chat({ userName, setUserName }) {
  const [message, setMessage] = useState("");
  const [chat, setChat] = useState([]);
  const messagesEndRef = useRef(null);

  useEffect(() => {
    socket.on("chat-message", (msg) => {
      setChat((prev) => [...prev, msg]);
    });
    return () => {
      socket.off("chat-message");
    };
  }, []);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [chat]);

  const sendMessage = (e) => {
    e.preventDefault();
    if (!userName || !message.trim()) return;
    socket.emit("chat-message", { name: userName, text: message });
    setMessage("");
  };

  return (
    <div
      style={{
        border: "1px solid #ccc",
        padding: 10,
        maxWidth: 400,
        margin: "10px auto",
      }}
    >
      <div style={{ marginBottom: 8 }}>
        <input
          type="text"
          placeholder="Ваше имя"
          value={userName}
          onChange={(e) => setUserName(e.target.value)}
          style={{ width: "60%", marginRight: 8 }}
        />
      </div>
      <div
        style={{
          height: 200,
          overflowY: "auto",
          background: "#f9f9f9",
          marginBottom: 8,
          padding: 4,
        }}
      >
        {chat.map((msg, idx) => (
          <div key={idx}>
            <b>{msg.name || "Аноним"}:</b> {msg.text}
          </div>
        ))}
        <div ref={messagesEndRef} />
      </div>
      <form onSubmit={sendMessage} style={{ display: "flex" }}>
        <input
          type="text"
          placeholder="Введите сообщение"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          style={{ flex: 1, marginRight: 8 }}
        />
        <button type="submit">Отправить</button>
      </form>
    </div>
  );
}
